export default __webpack_public_path__ + "static/media/Prophecy_Cn.e7022150.webp";